<!--
 * @Author: tony.zhu
 * @Date: 2025-10-15 10:33:51
 * @LastEditTime: 2025-10-16 18:26:24
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-main">
    <div class="c-main__menu" v-show="!imagePreviewVisible">
      <Menu v-bind="$attrs" v-on="$listeners"></Menu>
    </div>
    <div class="c-main__content" :class="{ 'is-preview': imagePreviewVisible }">
      <Content v-bind="$attrs" v-on="$listeners" @open-image-preview="handleOpenImagePreview" @open-file-preview="handleOpenFilePreview"></Content>
    </div>
    <div class="c-main__preview" v-if="imagePreviewVisible">
      <div class="preview-header">
        <span class="preview-title">{{ previewType === 'image' ? '图片预览' : '文件预览' }}</span>
        <i class="el-icon-close" @click="handleClosePreview"></i>
      </div>
      <div class="preview-content" v-loading="previewType === 'file' && previewLoading">
        <template v-if="previewType === 'image'">
          <img :src="currentPreviewImage.url" :alt="currentPreviewImage.name" class="preview-image" />
        </template>
        <template v-else>
          <iframe :src="currentPreviewImage.url" class="preview-iframe" frameborder="0"></iframe>
        </template>
        <div class="preview-info">
          <p class="image-name">{{ currentPreviewImage.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/aiChat/components/sidebar/index.vue'
import Content from './content.vue'
import COS from 'cos-js-sdk-v5'
import { Api } from '@/api'

export default {
  components: {
    Menu,
    Content,
  },
  data() {
    return {
      imagePreviewVisible: false,
      previewType: 'image',
      previewLoading: false,
      currentPreviewImage: {
        url: '',
        name: ''
      }
    }
  },
  methods: {
    handleOpenImagePreview(image) {
      this.currentPreviewImage = image
      this.previewType = 'image'
      this.imagePreviewVisible = true
    },
    handleOpenFilePreview(file) {
      // 先展示预览面板
      this.currentPreviewImage = { url: '', name: file.name }
      this.previewType = 'file'
      this.previewLoading = true
      this.imagePreviewVisible = true

      // fetch 文件 → Blob → 上传腾讯云 COS → COS 文档预览 URL
      fetch(file.url, { method: 'get' })
        .then(res => {
          if (res.status !== 200) {
            return res.json().then(err => { throw err })
          }
          return res.arrayBuffer()
        })
        .then(arrayBuffer => {
          const blob = new Blob([arrayBuffer])
          return Api.generatorTempSecretId({ filename: file.name, type: '1' }).then(res => {
            if (res && res.code === '0') {
              return new Promise((resolve, reject) => {
                const cos = new COS({
                  SecretId: res.data.tmpSecretId,
                  SecretKey: res.data.tmpSecretKey,
                  XCosSecurityToken: res.data.sessionToken
                })
                cos.uploadFile({
                  Bucket: res.data.bucket,
                  Region: res.data.region,
                  Key: res.data.path,
                  Body: blob
                }, function(err, data) {
                  if (err) {
                    reject(err)
                  } else {
                    const previewUrl = 'https://' + data.Location + '?ci-process=doc-preview&dstType=html#toolbar=0&navpanes=0'
                    resolve(previewUrl)
                  }
                })
              })
            } else {
              throw new Error('获取上传凭证失败')
            }
          })
        })
        .then(previewUrl => {
          this.currentPreviewImage = { url: previewUrl, name: file.name }
          this.previewLoading = false
        })
        .catch(err => {
          console.error('文件预览加载失败', err)
          this.previewLoading = false
          this.$message.warning('文件预览加载失败')
        })
    },
    handleClosePreview() {
      this.imagePreviewVisible = false
      this.previewType = 'image'
      this.previewLoading = false
      this.currentPreviewImage = {
        url: '',
        name: ''
      }
    }
  },
  mounted() {
    this.$bus.$on('open-file-preview', this.handleOpenFilePreview)
  },
  beforeDestroy() {
    this.$bus.$off('open-file-preview', this.handleOpenFilePreview)
  }
};
</script>

<style lang="scss" scoped>
.c-main {
  height: calc(100% - 48px);
  display: flex;
  max-width: 1200px;
  margin: 0 auto;

  .c-main__menu {
    width: 260px;
    height: 100%;
    flex-shrink: 0;
    background: linear-gradient(
      46deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0.5) 14%,
      rgba(255, 255, 255, 0.6) 34%,
      rgba(255, 255, 255, 0.6) 80%,
      rgba(255, 255, 255, 0.6) 100%
    );
    box-shadow: inset -1px 0px 0px 0px #e9ebf2;
    transition: all 0.3s ease;
  }

  .c-main__content {
    width: 100%;
    overflow: hidden;
    transition: all 0.3s ease;

    &.is-preview {
      width: 600px;
      flex-shrink: 0;
    }
  }

  .c-main__preview {
    width: 600px;
    height: 100%;
    flex-shrink: 0;
    background: #fff;
    box-shadow: inset 1px 0px 0px 0px #e9ebf2;
    display: flex;
    flex-direction: column;

    .preview-header {
      height: 48px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e9ebf2;

      .preview-title {
        font-size: 16px;
        font-weight: 500;
        color: #1d2129;
      }

      .el-icon-close {
        font-size: 20px;
        cursor: pointer;
        color: #86909c;

        &:hover {
          color: #1d2129;
        }
      }
    }

    .preview-content {
      flex: 1;
      overflow: auto;
      padding: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .preview-image {
        max-width: 100%;
        max-height: calc(100% - 60px);
        object-fit: contain;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      .preview-iframe {
        width: 100%;
        height: calc(100% - 60px);
        flex: 1;
        border: 1px solid #e9ebf2;
        border-radius: 4px;
      }

      .preview-info {
        margin-top: 16px;
        width: 100%;

        .image-name {
          font-size: 14px;
          color: #4e5969;
          text-align: center;
          word-break: break-all;
        }
      }
    }
  }
}
</style>